import { AwsS3 } from './aws';

export async function deleteFile(targetBucket: string, key: string) {
  const s3Handler = await AwsS3.create(targetBucket, key);
  return s3Handler.deleteObject();
}
